import api, { unwrap } from './client';

/* Résumés de l'ACCUEIL — quelques chiffres par module, et rien d'autre.
   Une route par périmètre : un appel refusé (403) veut dire « cette personne ne
   lit pas ce module », et sa carte ne s'affiche pas. */
export const getFinanceHome = (tid, year) =>
  unwrap(api.get(`/financials/home/${tid}?year=${year}`));

export const getSalesHome = (tid, year) =>
  unwrap(api.get(`/sales-plan/home/${tid}?year=${year}`));

export const getPeopleHome = (tid, year) =>
  unwrap(api.get(`/hr/home/${tid}?year=${year}`));
